import { mount } from "@vue/test-utils";
import InputTip from "@/components/core/custom/InputTip";

describe("InputTip test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(InputTip);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component InputTip", () => {
    expect(wrapper).toBeDefined();
  });
});
